import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import VisibilitySensor from 'react-visibility-sensor';
import {exposeTest} from '../../../../actions/mvt';
import {getValue} from '../../../../utils/abacus';

export function mapStateToProps(state, ownProps) {
    const {abacus} = state;
    const {test} = ownProps;
    const variant = getValue(abacus, test);
    return {variant};
}

export class MvtTestComponent extends Component {
    static propTypes = {
        test: PropTypes.string,
        variant: PropTypes.number,
        exposureMinTop: PropTypes.number,
        report: PropTypes.bool,
        children: PropTypes.node,
        abacus: PropTypes.object
    };

    static defaultProps = {
        exposureMinTop: 10
    };

    reportExposure(children, minTopValue) {
        const {test} = this.props;

        return (
            <VisibilitySensor
                partialVisibility
                minTopValue={minTopValue}
                delayedCall
                onChange={this.onVisibilityChange}
                className={test}
            >
                {children ? children : <span />}
            </VisibilitySensor>
        );
    }

    onVisibilityChange = (isVisible) => {
        if (!isVisible) {
            return;
        }

        const {test, variant, abacus} = this.props;

        if (this.props.exposeTest) {
            this.props.exposeTest(test, variant, abacus);
        } else if (this.props.dispatch) {
            // mvt reducer handles the deduplication of events
            this.props.dispatch(exposeTest(test, variant, abacus));
        }
    };

    render() {
        const {test, variant, report, exposureMinTop} = this.props;
        const children = (
            <div className={`${test} ${test}${variant}`}>
                {this.props.children}
            </div>
        );

        const allowReport = report && variant !== -1;

        return allowReport
            ? this.reportExposure(children, exposureMinTop)
            : children;
    }
}

export const MvtTest = connect(mapStateToProps)(MvtTestComponent);
export default MvtTest;
